$(document).ready(function() {

  /* resend email function */

  $('.byg_resendEmail').click(function() {
    bg_utils.hide('.byg_resendEmailSuccess');
    bg_utils.hide('.byg_resendEmailError');
    $.ajax({
      'url': bg_consts.API.CUSTOMER_REGISTRATION_RESEND,
      'type': 'POST',
      'dataType': 'json', // expected type from server
      'data': {
        'email': $('input[name="email"]').val(),
      },
      'success': function(data, status, xhr) {
        if (data.status === 'OK') {
          bg_utils.show('.byg_resendEmailSuccess');
        }
        else {
          bg_utils.show('.byg_resendEmailError');
        }
      },
      'error': function(xhr, status, error) {
        bg_utils.show('.byg_resendEmailError');
      },
    });
  });

  /* constants */

  var STATE_CHECK = 1;
  var STATE_SUBMIT = 2;

  /* state: the current state of submission. 1: check values, 2 confirm and
   * submit. */

  var state = STATE_CHECK;

  /* setup variables for form validator */

  var what = '.bg-content__signup-form-merchant';

  var url = bg_consts.API.CUSTOMER_REGISTRATION;

  var messages = {
    'password': {
        'pattern': bg_globals.i18n.form.errors.password_pattern
    },
    'passwordCheck': {
      'equalTo': bg_globals.i18n.form.errors.password_mismatch,
    },
    'captcha': {
      'required': bg_globals.i18n.form.errors.captcha,
    },
  };

  var rules = {
    'name': {
      'only_letters': true,
    },
    'surname': {
      'only_letters': true,
    },
    'mobilePhone': {
      'phone_min_9_digits_es_prefix': true,
    },
    'email': {
      'email': true,
    },
    'password': {
        'pattern': bg_consts.SIGNUP_FORMS.PASSWORD_REGEX
    },
    'passwordCheck': {
      'equalTo': '.bg-content__signup-form-merchant input[name="password"]',
    },
    'captcha': {
      'required': function() {
        return grecaptcha.getResponse() === '';
      },
    },
  };

  var alertBox = '.byg_alertError';

  var successFnc = function() {
    if (state === STATE_CHECK) {
      bg_utils.log('everything went ok, goto state 2');
      gotoState2();
    }
    else {
      window.location.href = bg_globals.base_url + 'customer-signup-otp-confirm';
    }
  };

  /* gotoState1
   * setup the form for step 1: check button only, editable fields */

  var gotoState1 = function() {
    state = STATE_CHECK;
    $(what + ' input[name="check"]').attr('value', true);
    $(what + ' :input').attr('readonly', false);
    $(what + ' .bg-modify-btn').addClass('hidden');
    $(what + ' .bg-submit-btn').addClass('hidden');
    $(what + ' .bg-check-btn').removeClass('hidden');
    $(what + ' .bg-cancel-btn').removeClass('hidden');
    $(what + ' .byg_alertReview').addClass('hidden');
    $(what + ' .byg_alertError').addClass('hidden');
    $(what).removeClass('bygForm--usercheck');
    /*empty password fields*/
    $("[name=password],[name=passwordCheck]").val('');
    bg_utils.captchaReset();
    bg_utils.scrollToElement('.bg-content__signup-form-merchant>h1');
  };

  /* gotoState2
   * setup the form for step 2: 'edit' and 'submit' buttons, read-only fields */

  var gotoState2 = function() {
    state = STATE_SUBMIT;
    $(what + ' input[name="check"]').attr('value', false);
    $(what + ' :input').not('button').attr('readonly', true);
    $(what + ' .bg-modify-btn').removeClass('hidden');
    $(what + ' .bg-submit-btn').removeClass('hidden');
    $(what + ' .bg-check-btn').addClass('hidden');
    $(what + ' .bg-cancel-btn').addClass('hidden');
    $(what + ' .byg_alertReview').removeClass('hidden');
    $(what).addClass('bygForm--usercheck');
    bg_utils.scrollToElement(".byg_alertReview");
  };

  /* bind event on 'modify' button */

  $(what + ' .bg-modify-btn').click(gotoState1);

  /* entry point */
  bg_validator.validateV2(
      what,
      url,
      messages,
      rules,
      alertBox,
      successFnc,
      {'extraErrorFnc': bg_utils.captchaReset, 'scrollInView': true});

  gotoState1();

  $(what).submit(function() {
    var $phoneInput = $(what + ' input[name="mobilePhone"]')[0];
    $phoneInput.value = bg_utils.uidProcessor($phoneInput.value); //removes prefix
    return true; // return false to cancel form action
  });

  bg_utils.initCaptchaInViews();
});
